export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="practice-marquee" className="overflow-hidden border-y border-slate-200 bg-[#F4F6F9] py-6">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {row.map((it, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-serif text-2xl text-[#0F2137] md:text-3xl">
                <span className="px-8">{it}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#3B5B85]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
